let sessionToken = null;

const TOKEN_STORAGE_KEY = 'token';
const TOKEN_STORAGE_KEY_ALT = 'waseeny_token';

export const setSessionToken = (token) => {
  sessionToken = token || null;
  try {
    if (token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
      localStorage.setItem(TOKEN_STORAGE_KEY_ALT, token);
      localStorage.setItem('waseeny_isAuthenticated', 'true');
    } else {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      localStorage.removeItem(TOKEN_STORAGE_KEY_ALT);
      localStorage.setItem('waseeny_isAuthenticated', 'false');
    }
  } catch (e) {
    // ignore localStorage errors (e.g. private browsing quota)
  }
};

export const getSessionToken = () => {
  if (sessionToken) {
    return sessionToken;
  }
  try {
    const stored = localStorage.getItem(TOKEN_STORAGE_KEY) || localStorage.getItem(TOKEN_STORAGE_KEY_ALT);
    if (stored) {
      sessionToken = stored;
      return stored;
    }
  } catch (e) {
    // ignore localStorage errors
  }
  return null;
};

export const clearSessionToken = () => {
  sessionToken = null;
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(TOKEN_STORAGE_KEY_ALT);
    localStorage.removeItem('user');
    localStorage.setItem('waseeny_isAuthenticated', 'false');
  } catch (e) {
    // ignore localStorage errors
  }
};
